<div class="library-list d-flex justify-content-between px-4 py-3 px-md-8 py-md-6">
  <div>
    <fa-icon [icon]="bookReaderIcon" class="mr-3 library-list-icon"></fa-icon>
    <div class="d-inline-flex flex-column justify-content-center">
      <h2 class="library-list-title" data-automation-id="library-list-title">
        {{libraryList.name}}
      </h2>
      <div class="library-list-subtitle d-flex align-items-center flex-wrap">
        <div class="mr-6" data-automation-id="library-list-counter">{{'libraryList' | translate}} | {{'libraryListItemsCount' | translate: {count: itemsCount} }}</div>
        <div *ngIf="libraryList.creator" class="d-flex align-items-center library-list-creator" data-automation-id="library-list-creator">
          <fa-icon [icon]="userIcon" class="mr-1"></fa-icon>
          <span class="label mr-1" translate>customShowcaseCreatedBy</span>
          <span class="name">{{libraryList.creator}}</span>
        </div>
      </div>
    </div>
  </div>
  <button
    *ngIf="libraryListType === LibraryListTypes.SHOWCASE && libraryCreatedFrom === CustomShowcaseCreatedFromType.savedSearch && isSearchShowcaseEnabled"
    (click)="runSavedSearch()"
    class="ins-buttons button-primary flint mt-2"
    translate
    data-automation-id="library-list-run-search">
    <span class="fas fa-search mr-2" aria-hidden="true"></span>
    customShowcaseRunSavedSearch
  </button>

  <div class="search-input ml-auto" *ngIf="libraryListType === LibraryListTypes.SHOWCASE && libraryCreatedFrom === CustomShowcaseCreatedFromType.list && isSearchShowcaseEnabled">
    <input
      type="text"
      aria-label="{{ 'searchInputPlaceholder' | translate }}"
      [(ngModel)]="searchTerm"
      (input)="onSearchTermChange()"
      placeholder="{{ 'searchInputPlaceholder' | translate }}"
      class="form-control search-showcase-input"
      data-automation-id="search-showcase-input"
    />
  </div>
</div>
